// Ứng với enum ExamResultStatus ở BE.
export const examResultStatusEnum = { 
  processing: 0,
  hadResult: 1,
  hadSentResult: 2,
  cancel: 3
}